export type StatusTone = "healthy" | "warning" | "unhealthy" | "neutral" | "info" | "offline" | "maintenance";

export function normalizeStatusTone(status: string | undefined): StatusTone {
  const value = String(status ?? "").toLowerCase();
  if (["healthy", "running", "active", "ok", "success"].includes(value)) return "healthy";
  if (["not_started", "warning", "degraded", "pending", "medium"].includes(value)) return "warning";
  if (["unhealthy", "failed", "stopped", "cancelled", "error", "high", "critical"].includes(value)) {
    return "unhealthy";
  }
  if (["offline", "disconnected", "unknown", "unavailable"].includes(value)) return "offline";
  if (["maintenance", "paused", "suspended"].includes(value)) return "maintenance";
  if (["info", "open", "new"].includes(value)) return "info";
  return "neutral";
}

export function statusToneClasses(tone: StatusTone): string {
  switch (tone) {
    case "healthy":
      return "border-status-success-border bg-status-success-surface text-status-success";
    case "warning":
      return "border-status-warning-border bg-status-warning-surface text-status-warning";
    case "unhealthy":
      return "border-status-error-border bg-status-error-surface text-status-error";
    case "info":
      return "border-status-info-border bg-status-info-surface text-status-info";
    case "offline":
      return "border-status-offline-border bg-status-offline-surface text-status-offline";
    case "maintenance":
      return "border-status-maintenance-border bg-status-maintenance-surface text-status-maintenance";
    default:
      return "border-card-border bg-muted-bg text-muted";
  }
}
